import { useMemo } from 'react';

import { Button } from '@gearbelt/ui/components';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Form, FormFieldItem } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { useWorkspaceSetupStore, WorkspaceSetupSteps } from '@/stores/workspace-setup.store';

import { WorkspaceSetUpProps } from './workspace-setup.utils';

export const WorkspaceSetupNameModal = ({ form, register, onNextStep }: WorkspaceSetUpProps) => {
  const { workspaceSetupStep } = useWorkspaceSetupStore();
  const workspaceName = form.watch('workspaceName');

  const isCreateButtonDisabled = useMemo(() => {
    const isDirty = form.getFieldState('workspaceName').isDirty;
    const hasError = !!form.formState.errors.workspaceName;
    const isEmpty = workspaceName.length === 0 && isDirty;
    return !isDirty || hasError || isEmpty;
  }, [workspaceName]);

  return (
    <Dialog open={workspaceSetupStep === WorkspaceSetupSteps.WorkspaceName}>
      <DialogContent className="top-[210px] h-fit w-[400px] gap-0 p-8">
        <DialogHeader className="flex flex-col items-start justify-center space-y-0 pb-2">
          <DialogTitle className={cn('text-default-text pb-2 text-xl')} hideCloseButton={true}>
            <span className="font-medium"> Create workspace</span>
          </DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form className="flex flex-col gap-2">
            <div className="animate-in slide-in-from-top-3 flex flex-col gap-2 duration-500">
              <FormFieldItem control={form.control} name="workspaceName" label="Workspace name">
                {({ value, error }) => (
                  <Input
                    placeholder="Workspace name"
                    value={value as string}
                    error={!!error}
                    {...register('workspaceName')}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && onNextStep) {
                        e.preventDefault();
                        onNextStep();
                        e.currentTarget.blur();
                      }
                    }}
                  />
                )}
              </FormFieldItem>

              <Button variant="success" className="mt-3 w-fit text-base" type="button" disabled={isCreateButtonDisabled} onClick={onNextStep}>
                Create Workspace
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
